import React, { type ReactElement } from 'react';

type Props = {
    onClick: (event: React.MouseEvent) => void;
    tooltip?: string;
    disabled?: boolean;
};

export const RemoveButton: (props: Props) => ReactElement<Props> = ({ onClick, tooltip, disabled }: Props) => {
    return (
        <button className='btn btn-xs btn-danger' onClick={onClick} title={tooltip} disabled={disabled}>
            <i className='icon fas fa-times' />
        </button>
    );
};
